<div>
  <div class="row">
    <div class="col-12">
      <span class="tlm-header">Social Media</span>
    </div>
  </div>
  <div class="row no-gutters">
    <div class="col-12">
      <form class="needs-validation" novalidate [formGroup]="socialMediaFormFormGroup">
        <div class="row">
          <div class="col-12">
            <app-tlm-edit-threat-social-medias
              [socialMediasFormArray]="socialMediaFormFormGroup.get(formNames.socialMediaList)"
              [socialMediaTypes]="socialMediaTypes"
              [matAppearance]="matAppearance"
              [errorMatcher]="errorMatcher"
            >
            </app-tlm-edit-threat-social-medias>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
